import { render, staticRenderFns } from "./SupplierManufacturingHealthSafety.vue?vue&type=template&id=f207d46e&scoped=true&"
import script from "./SupplierManufacturingHealthSafety.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingHealthSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f207d46e",
  null
  
)

export default component.exports